"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pageMargins = exports.contentWrapper = exports.padding = exports.margin = exports.extrabold = exports.semibold = exports.regular = exports.letterSpacing = exports.fontWeight = exports.lineHeight = exports.getLineHeight = exports.fontSize = exports.getFontSize = exports.isMedia = exports.mediaMax = exports.media = exports.contentWidth = exports.pageMargin = exports.breakpoint = exports.breakpoints = exports.typography = exports.spacing = exports.color = exports.background = exports.omitCssProps = exports.addCssProp = void 0;

var _styledComponents = require("styled-components");

var _selectors = require("../themes/selectors");

var _addCssProp2 = _interopRequireWildcard(require("./addCssProp"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _templateObject42() {
  var data = _taggedTemplateLiteral(["\n  padding: 0 ", "px;\n  @media (min-width: ", "px) {\n    margin: 0 ", "%;\n  }\n  @media (min-width: ", "px) {\n    margin: 0 ", "%;\n  }\n  @media (min-width: ", "px) {\n    margin: 0 ", "%;\n  }\n  @media (min-width: ", "px) {\n    margin: 0 ", "%;\n  }\n"]);

  _templateObject42 = function _templateObject42() {
    return data;
  };

  return data;
}

function _templateObject41() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  max-width: ", "px;\n"]);

  _templateObject41 = function _templateObject41() {
    return data;
  };

  return data;
}

function _templateObject40() {
  var data = _taggedTemplateLiteral(["\n          ", "\n        "]);

  _templateObject40 = function _templateObject40() {
    return data;
  };

  return data;
}

function _templateObject39() {
  var data = _taggedTemplateLiteral(["\n          ", "\n        "]);

  _templateObject39 = function _templateObject39() {
    return data;
  };

  return data;
}

function _templateObject38() {
  var data = _taggedTemplateLiteral(["\n        ", "\n        ", "\n        ", "\n      "]);

  _templateObject38 = function _templateObject38() {
    return data;
  };

  return data;
}

function _templateObject37() {
  var data = _taggedTemplateLiteral(["\n          ", "\n          ", "\n        "]);

  _templateObject37 = function _templateObject37() {
    return data;
  };

  return data;
}

function _templateObject36() {
  var data = _taggedTemplateLiteral(["\n          ", "\n          ", "\n        "]);

  _templateObject36 = function _templateObject36() {
    return data;
  };

  return data;
}

function _templateObject35() {
  var data = _taggedTemplateLiteral(["\n        ", "\n        ", "\n        ", "\n        ", "\n      "]);

  _templateObject35 = function _templateObject35() {
    return data;
  };

  return data;
}

function _templateObject34() {
  var data = _taggedTemplateLiteral(["\n          ", "\n          ", "\n        "]);

  _templateObject34 = function _templateObject34() {
    return data;
  };

  return data;
}

function _templateObject33() {
  var data = _taggedTemplateLiteral(["\n          ", "\n          ", "\n        "]);

  _templateObject33 = function _templateObject33() {
    return data;
  };

  return data;
}

function _templateObject32() {
  var data = _taggedTemplateLiteral(["\n        ", "\n        ", "\n        ", "\n        ", "\n      "]);

  _templateObject32 = function _templateObject32() {
    return data;
  };

  return data;
}

function _templateObject31() {
  var data = _taggedTemplateLiteral(["\n          ", "\n        "]);

  _templateObject31 = function _templateObject31() {
    return data;
  };

  return data;
}

function _templateObject30() {
  var data = _taggedTemplateLiteral(["\n          ", "\n        "]);

  _templateObject30 = function _templateObject30() {
    return data;
  };

  return data;
}

function _templateObject29() {
  var data = _taggedTemplateLiteral(["\n        ", "\n        ", "\n        ", "\n      "]);

  _templateObject29 = function _templateObject29() {
    return data;
  };

  return data;
}

function _templateObject28() {
  var data = _taggedTemplateLiteral(["\n          ", "\n        "]);

  _templateObject28 = function _templateObject28() {
    return data;
  };

  return data;
}

function _templateObject27() {
  var data = _taggedTemplateLiteral(["\n          ", "\n        "]);

  _templateObject27 = function _templateObject27() {
    return data;
  };

  return data;
}

function _templateObject26() {
  var data = _taggedTemplateLiteral(["\n        ", "\n        ", "\n        ", "\n      "]);

  _templateObject26 = function _templateObject26() {
    return data;
  };

  return data;
}

function _templateObject25() {
  var data = _taggedTemplateLiteral(["\n          ", "\n        "]);

  _templateObject25 = function _templateObject25() {
    return data;
  };

  return data;
}

function _templateObject24() {
  var data = _taggedTemplateLiteral(["\n          ", "\n        "]);

  _templateObject24 = function _templateObject24() {
    return data;
  };

  return data;
}

function _templateObject23() {
  var data = _taggedTemplateLiteral(["\n        ", "\n        ", "\n        ", "\n      "]);

  _templateObject23 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22() {
  var data = _taggedTemplateLiteral(["\n          ", "\n        "]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = _taggedTemplateLiteral(["\n          ", "\n        "]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral(["\n        ", "\n        ", "\n        ", "\n      "]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n      font-weight: ", ";\n    "]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n      font-weight: ", ";\n    "]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n      font-weight: ", ";\n    "]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  letter-spacing: ", ";\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  font-weight: ", ";\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n    line-height: ", ";\n  "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n    line-height: ", ";\n  "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  line-height: ", ";\n  ", "\n  ", "\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    font-size: ", ";\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    font-size: ", ";\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", ";\n  ", "\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    @media (max-width: ", "px) {\n      ", ";\n    }\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    @media (min-width: ", "px) {\n      ", ";\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var addCssProp = _addCssProp2["default"];
exports.addCssProp = addCssProp;
var omitCssProps = _addCssProp2.omitCssProps; // Global style variables

exports.omitCssProps = omitCssProps;
var background = {
  app: '#F6F9FC',
  appInverse: '#7A8997',
  positive: '#E1FFD4',
  negative: '#FEDED2',
  warning: '#FFF5CF'
};
exports.background = background;
var color = {
  // Palette
  primary: '#00B5E2',
  // azure
  secondary: '#7D55C7',
  // purple
  tertiary: '#DDDDDD',
  white: '#FFFFFF',
  black: '#000000',
  azure: '#00B5E2',
  orange: '#FFC13F',
  purple: '#7D55C7',
  blue: '#192377',
  darkBlue: '#192128',
  red: '#DC0000',
  yellow: '#F8E73C',
  grey: '#192128',
  lightGrey: '#bbbbbb',
  // Monochrome
  lightest: '#FFFFFF',
  lighter: '#F8F8F8',
  light: '#F3F3F3',
  mediumlight: '#EEEEEE',
  medium: '#DDDDDD',
  mediumdark: '#999999',
  dark: '#666666',
  darker: '#444444',
  darkest: '#333333',
  border: 'rgba(0,0,0,.1)',
  // Status
  positive: '#66BF3C',
  negative: '#FF4400',
  warning: '#E69D00'
};
exports.color = color;
var spacing = {
  margin: {
    mobile: {
      s: '10',
      m: '20',
      l: '40',
      xl: '50'
    },
    tablet: {
      s: '20',
      m: '32',
      l: '56',
      xl: '60'
    },
    desktop: {
      s: '20',
      m: '32',
      l: '56',
      xl: '60'
    }
  },
  padding: {
    mobile: {
      s: '10',
      m: '20',
      l: '40',
      xl: '50'
    },
    tablet: {
      s: '20',
      m: '32',
      l: '56',
      xl: '60'
    },
    desktop: {
      s: '20',
      m: '32',
      l: '56',
      xl: '60'
    }
  },
  borderRadius: {
    s: '2px',
    m: '5px',
    l: '10px'
  }
};
exports.spacing = spacing;
var typography = {
  type: {
    fontFamily: '"Montserrat", Arial, sans-serif',
    code: '"SFMono-Regular", Consolas, "Liberation Mono", Menlo, Courier, monospace'
  },
  weight: {
    medium: '500',
    semibold: '600',
    extrabold: '800'
  },
  size: {
    mobile: {
      xxxs: '8px',
      xxs: '10px',
      xs: '11.6px',
      s: '12.7px',
      base: '14.5px',
      m: '19px',
      l: '26.2px',
      xl: '39px'
    },
    tablet: {
      xxxs: '10px',
      xxs: '12,5px',
      xs: '14,5px',
      s: '15.8px',
      base: '18.1px',
      m: '23.7px',
      l: '32.7px',
      xl: '48.7px'
    },
    desktop: {
      xxxs: '11px',
      xxs: '13.5px',
      xs: '15px',
      s: '16.5px',
      base: '18.8px',
      m: '24.7px',
      l: '34px',
      xl: '50.7px'
    }
  },
  lineHeight: {
    mobile: {
      s: '1.1em',
      m: '1.21em',
      l: '1.31em',
      xl: '1.41em'
    },
    tablet: {
      s: '1.1em',
      m: '1.21em',
      l: '1.31em',
      xl: '1.41em'
    },
    desktop: {
      s: '1.1em',
      m: '1.21em',
      l: '1.31em',
      xl: '1.41em'
    }
  },
  letterSpacing: 'normal'
};
exports.typography = typography;
var breakpoints = {
  mobile: 320,
  tablet: 768,
  desktop: 1024
};
exports.breakpoints = breakpoints;
var breakpoint = 600;
exports.breakpoint = breakpoint;
var pageMargin = '5.55555';
exports.pageMargin = pageMargin;
var contentWidth = 600;
exports.contentWidth = contentWidth;
var media = Object.keys(breakpoints).reduce(function (acc, label) {
  acc[label] = function () {
    return (0, _styledComponents.css)(_templateObject(), breakpoints[label], _styledComponents.css.apply(void 0, arguments));
  };

  return acc;
}, {});
exports.media = media;
var mediaMax = Object.keys(breakpoints).reduce(function (acc, label) {
  acc[label] = function () {
    return (0, _styledComponents.css)(_templateObject2(), breakpoints[label], _styledComponents.css.apply(void 0, arguments));
  };

  return acc;
}, {});
exports.mediaMax = mediaMax;

var isMedia = function isMedia() {
  var mediaLabel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'desktop';
  return window.innerWidth >= breakpoints[mediaLabel];
};

exports.isMedia = isMedia;

var getFontSize = function getFontSize() {
  var mobile = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : typography.size.mobile.base;
  var tablet = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : typography.size.tablet.base;
  var desktop = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : typography.size.desktop.base;
  return (0, _styledComponents.css)(_templateObject3(), mobile, media.tablet(_templateObject4(), tablet), media.desktop(_templateObject5(), desktop));
};

exports.getFontSize = getFontSize;

var fontSize = function fontSize() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'base';
  return (0, _styledComponents.css)(_templateObject6(), function (props) {
    var themeTypography = (0, _selectors.typography)(props);
    return getFontSize(themeTypography.size.mobile[size], themeTypography.size.tablet[size], themeTypography.size.desktop[size]);
  });
};

exports.fontSize = fontSize;

var getLineHeight = function getLineHeight() {
  var mobile = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : typography.lineHeight.mobile.base;
  var tablet = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : typography.lineHeight.tablet.base;
  var desktop = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : typography.lineHeight.desktop.base;
  return (0, _styledComponents.css)(_templateObject7(), mobile, media.tablet(_templateObject8(), tablet), media.desktop(_templateObject9(), desktop));
};

exports.getLineHeight = getLineHeight;

var lineHeight = function lineHeight() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'base';
  return (0, _styledComponents.css)(_templateObject10(), function (props) {
    var themeTypography = (0, _selectors.typography)(props);
    return getLineHeight(themeTypography.lineHeight.mobile[size], themeTypography.lineHeight.tablet[size], themeTypography.lineHeight.desktop[size]);
  });
};

exports.lineHeight = lineHeight;

var fontWeight = function fontWeight() {
  var weight = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'medium';
  return (0, _styledComponents.css)(_templateObject11(), function (props) {
    var themeTypography = (0, _selectors.typography)(props);
    return themeTypography.weight[weight];
  });
};

exports.fontWeight = fontWeight;

var letterSpacing = function letterSpacing() {
  return (0, _styledComponents.css)(_templateObject12(), function (props) {
    var themeTypography = (0, _selectors.typography)(props);
    return themeTypography.letterSpacing;
  });
};

exports.letterSpacing = letterSpacing;

var regular = function regular() {
  return (0, _styledComponents.css)(_templateObject13(), function (props) {
    var themeTypography = (0, _selectors.typography)(props);
    return (0, _styledComponents.css)(_templateObject14(), themeTypography.weight.medium);
  });
};

exports.regular = regular;

var semibold = function semibold() {
  return (0, _styledComponents.css)(_templateObject15(), function (props) {
    var themeTypography = (0, _selectors.typography)(props);
    return (0, _styledComponents.css)(_templateObject16(), themeTypography.weight.semibold);
  });
};

exports.semibold = semibold;

var extrabold = function extrabold() {
  return (0, _styledComponents.css)(_templateObject17(), function (props) {
    var themeTypography = (0, _selectors.typography)(props);
    return (0, _styledComponents.css)(_templateObject18(), themeTypography.weight.extrabold);
  });
};

exports.extrabold = extrabold;

var spacingCss = function spacingCss(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'margin' : _ref$type,
      direction = _ref.direction,
      query = _ref.query,
      size = _ref.size;
  return (0, _styledComponents.css)(_templateObject19(), function (props) {
    var themeSpacing = (0, _selectors.spacing)(props);
    var sizeString = size !== 'none' ? "".concat(themeSpacing[type][query][size], "px") : '0';
    return direction ? "".concat(type, "-").concat(direction, ": ").concat(sizeString, ";") : "".concat(type, ": ").concat(sizeString, ";");
  });
};

var getSpacing = function getSpacing() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'margin';
  var size = arguments.length > 1 ? arguments[1] : undefined;
  var position = arguments.length > 2 ? arguments[2] : undefined;

  switch (position) {
    case 'left':
      return (0, _styledComponents.css)(_templateObject20(), spacingCss({
        type: type,
        direction: 'left',
        query: 'mobile',
        size: size
      }), media.tablet(_templateObject21(), spacingCss({
        type: type,
        direction: 'left',
        query: 'tablet',
        size: size
      })), media.desktop(_templateObject22(), spacingCss({
        type: type,
        direction: 'left',
        query: 'desktop',
        size: size
      })));

    case 'right':
      return (0, _styledComponents.css)(_templateObject23(), spacingCss({
        type: type,
        direction: 'right',
        query: 'mobile',
        size: size
      }), media.tablet(_templateObject24(), spacingCss({
        type: type,
        direction: 'right',
        query: 'tablet',
        size: size
      })), media.desktop(_templateObject25(), spacingCss({
        type: type,
        direction: 'right',
        query: 'desktop',
        size: size
      })));

    case 'top':
      return (0, _styledComponents.css)(_templateObject26(), spacingCss({
        type: type,
        direction: 'top',
        query: 'mobile',
        size: size
      }), media.tablet(_templateObject27(), spacingCss({
        type: type,
        direction: 'top',
        query: 'tablet',
        size: size
      })), media.desktop(_templateObject28(), spacingCss({
        type: type,
        direction: 'top',
        query: 'desktop',
        size: size
      })));

    case 'bottom':
      return (0, _styledComponents.css)(_templateObject29(), spacingCss({
        type: type,
        direction: 'bottom',
        query: 'mobile',
        size: size
      }), media.tablet(_templateObject30(), spacingCss({
        type: type,
        direction: 'bottom',
        query: 'tablet',
        size: size
      })), media.desktop(_templateObject31(), spacingCss({
        type: type,
        direction: 'bottom',
        query: 'desktop',
        size: size
      })));

    case 'vertical':
      return (0, _styledComponents.css)(_templateObject32(), spacingCss({
        type: type,
        direction: 'top',
        query: 'mobile',
        size: size
      }), spacingCss({
        type: type,
        direction: 'bottom',
        query: 'mobile',
        size: size
      }), media.tablet(_templateObject33(), spacingCss({
        type: type,
        direction: 'top',
        query: 'tablet',
        size: size
      }), spacingCss({
        type: type,
        direction: 'bottom',
        query: 'tablet',
        size: size
      })), media.desktop(_templateObject34(), spacingCss({
        type: type,
        direction: 'top',
        query: 'desktop',
        size: size
      }), spacingCss({
        type: type,
        direction: 'bottom',
        query: 'desktop',
        size: size
      })));

    case 'horizontal':
      return (0, _styledComponents.css)(_templateObject35(), spacingCss({
        type: type,
        direction: 'left',
        query: 'mobile',
        size: size
      }), spacingCss({
        type: type,
        direction: 'right',
        query: 'mobile',
        size: size
      }), media.tablet(_templateObject36(), spacingCss({
        type: type,
        direction: 'left',
        query: 'tablet',
        size: size
      }), spacingCss({
        type: type,
        direction: 'right',
        query: 'tablet',
        size: size
      })), media.desktop(_templateObject37(), spacingCss({
        type: type,
        direction: 'left',
        query: 'desktop',
        size: size
      }), spacingCss({
        type: type,
        direction: 'right',
        query: 'desktop',
        size: size
      })));

    default:
      return (0, _styledComponents.css)(_templateObject38(), spacingCss({
        type: type,
        query: 'mobile',
        size: size
      }), media.tablet(_templateObject39(), spacingCss({
        type: type,
        query: 'tablet',
        size: size
      })), media.desktop(_templateObject40(), spacingCss({
        type: type,
        query: 'desktop',
        size: size
      })));
  }
};

var margin = function margin() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'm';
  var position = arguments.length > 1 ? arguments[1] : undefined;
  return getSpacing('margin', size, position);
};

exports.margin = margin;

var padding = function padding() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'm';
  var position = arguments.length > 1 ? arguments[1] : undefined;
  return getSpacing('padding', size, position);
};

exports.padding = padding;
var contentWrapper = (0, _styledComponents.css)(_templateObject41(), contentWidth);
exports.contentWrapper = contentWrapper;
var pageMargins = (0, _styledComponents.css)(_templateObject42(), spacing.padding.medium, breakpoint * 1, pageMargin * 1, breakpoint * 2, pageMargin * 2, breakpoint * 3, pageMargin * 3, breakpoint * 4, pageMargin * 4);
exports.pageMargins = pageMargins;